export default "__VITE_ASSET__B8wkSun4__"